import { Box } from '@chakra-ui/react';

export function DiscountTag({ value }: { value: number }) {
  if (value <= 0 || value > 100) return null;

  return (
    <Box
      alignItems='center'
      as='span'
      bg='#FE914F'
      borderRadius='4px'
      color='white'
      display='inline-flex'
      fontSize='10px'
      fontWeight='600'
      lineHeight='12px'
      paddingX='8px'
      paddingY='4px'
      whiteSpace='nowrap'
    >
      {value}% Off
    </Box>
  );
}
